// Mirrors BrainChanger.Domain.Models.SettingsModels.UserSettingType.
// Kept as a hand-written local enum rather than sourced from the NSwag-generated client:
// it's only ever used as a bare query-string parameter on AddOrUpdateUserSetting, and NSwag
// doesn't emit TS enums for query parameters that aren't also referenced by a request/response
// body DTO, so a generated version disappears every time the client is regenerated.
export enum UserSettingType {
  Boolean = 0,
  Time = 1,
  Number = 2,
}
